module.exports = __webpack_public_path__ + "static/media/06_disable_Focus_of_attention.f5113c8f.svg";